import toast from 'react-hot-toast';
export const notif = (message: string = '', type: string = 'default', duration = 3000) => {
    const iconMap = {
        default: '✨',
        success: '✔️',
        error: '❌',
        warning: '⚠️',
        info: '📖',
    };
    toast(message, {
        icon: iconMap[type as keyof typeof iconMap],
        duration,
        style: {
            borderRadius: '10px',
            background: '#333',
            color: '#fff',
        },
    });
};

export const playCorrectAnswerSound = () => {
    const audio = new Audio(`${process.env.PUBLIC_URL}/sounds/CorrectAnswer.wav`);
    audio.play();
};
export const playWrongAnswerSound = () => {
    const audio = new Audio(`${process.env.PUBLIC_URL}/sounds/WrongAnswer.wav`);
    audio.play();
};
